import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { useTranslation } from 'react-i18next'
import { Dropdown } from 'react-bootstrap'
import Select from 'react-select'

import useDidMountEffect from 'pages/parts/useDidMountEffect'
import DeleteModal from 'pages/parts/DeleteModal'
import FilterSearch from 'pages/parts/FilterSearch'
import FilterPagination from 'pages/parts/FilterPagination'

import { httpOk, GET, DELETE, FILE_D, PUT } from 'helpers/api'
import { findKeyFromArrayByValue, formatMoney, returnSign, uploadUrl } from "helpers/helpers"
import CustomTooltip from "pages/parts/CustomTooltip"

function Index() {
	const { t } = useTranslation()

	const [productTypes, setProductTypes] = useState([])

	const statuses = [
		{ "id": 1, "name": t('success') },
		{ "id": -1, "name": t('deleted') },
	]

	const [data, setData] = useState([])
	const [modalDelete, setModalDelete] = useState(false)
	const [deleteModalParams, setDeleteModalParams] = useState({ id: 0, index: 0 })
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [filterDataExist, setFilterDataExist] = useState(false)
	const [filterData, setFilterData] = useState({
		'product_type': null,
		'status': 1,
		'search': '',
	})
	const [pagination, setPagination] = useState({
		url: '/products',
		response: null
	})

	function handleChangeProductType(item) {
		setFilterData({ ...filterData, product_type: item.id })
	}

	async function searchWithFilter(filterParams = { tableSort: "", }) {
		var filterDataCopy = { ...filterData }
		var filterUrl = "/products"
		var urlParams = ""
		checkFilter()

		if (filterDataCopy.status)
			urlParams += returnSign(urlParams) + 'status=' + filterDataCopy.status
		if (filterDataCopy.product_type)
			urlParams += returnSign(urlParams) + 'product_type=' + filterDataCopy.product_type
		if (filterDataCopy.search)
			urlParams += returnSign(urlParams) + 'search=' + filterDataCopy.search
		if (filterDataCopy.page)
			urlParams += returnSign(urlParams) + 'page=' + filterDataCopy.page
		if (filterDataCopy.size)
			urlParams += returnSign(urlParams) + 'size=' + filterDataCopy.size

		if (`/products${urlParams}` !== filterUrl)
			setFilterDataExist(true)

		if (filterParams.tableSort) {
			if (filterDataCopy.tableSortKey === filterParams.tableSort) {
				filterDataCopy.tableSortDirection === ',asc' ? filterDataCopy.tableSortDirection = ',desc' : filterDataCopy.tableSortDirection = ',asc'
			} else {
				filterDataCopy.tableSortDirection = ',asc'
			}
			filterDataCopy.tableSortKey = filterParams?.tableSort

			setFilterData(filterDataCopy)
			urlParams += returnSign(urlParams) + 'sort=' + filterParams.tableSort + filterDataCopy.tableSortDirection
		}

		filterUrl = filterUrl + urlParams
		var response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data.data)
			setPagination({ ...pagination, 'url': filterUrl, 'response': response.data })
		}

		setDropdownIsOpen(false)
	}

	async function downloadExcelFile() {
		var filterDataCopy = { ...filterData }
		var filterUrl = "/products-excel"
		var urlParams = ""

		if (filterDataCopy.status)
			urlParams += returnSign(urlParams) + 'status=' + filterDataCopy.status
		if (filterDataCopy.menu_id >= 0)
			urlParams += returnSign(urlParams) + 'menu_id=' + filterDataCopy.menu_id
		if (filterDataCopy.product_type)
			urlParams += returnSign(urlParams) + 'product_type=' + filterDataCopy.product_type
		if (filterDataCopy.search)
			urlParams += returnSign(urlParams) + 'search=' + filterDataCopy.search

		filterUrl = filterUrl + urlParams
		var response = await FILE_D(filterUrl)
		if (httpOk(response)) {
			// Создаем объект Blob из полученного файла
			const file = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

			// Создаем ссылку для скачивания файла
			const fileUrl = URL.createObjectURL(file);

			// Создаем ссылку для скачивания файла в браузере
			const link = document.createElement('a');
			link.href = fileUrl;
			link.setAttribute('download', `${t('products')}.xlsx`);
			document.body.appendChild(link);
			link.click();

			// Удаляем ссылку после скачивания файла
			URL.revokeObjectURL(fileUrl);
		}
	};

	function resetFilter() {
		setFilterData({
			pos_id: null,
			search: '',
		})
		searchWithFilter()
		setFilterDataExist(false)
	}

	function checkFilter() {
		if (
			filterData.pos_id === null &&
			filterData.search === ''
		) {
			setFilterDataExist(false)
		}
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	async function paginate(page, size) {
		setFilterData({ ...filterData, 'page': page, 'size': size })
	}

	async function deleteItem() {
		const response = await DELETE('/products', { 'id': deleteModalParams.id }, { loader: true })
		if (httpOk(response)) {
			searchWithFilter()
			setModalDelete(false)
		}
	}

	async function restoreItem(item) {
		var sendData = { ...item }
		sendData.id = item.id
		sendData.status = 1
		var response = await PUT('/products-status', sendData, { loader: true })
		if (httpOk(response)) {
			searchWithFilter()
			setModalDelete(false)
		}
	}

	async function getProductTypes() {
		const response = await GET('/helper/products-types')
		if (httpOk(response)) {
			setProductTypes(response.data)
		}
	}

	useEffect(() => {
		searchWithFilter()
		getProductTypes()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	useDidMountEffect(() => {
		searchWithFilter()
	}, [filterData.search, filterData.page, filterData.product_type, filterData.size]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('products')} [{pagination?.response?.total}]
				</h4>
				<div className="d-flex gap-2">
					<Link className="btn-rounded btn btn-primary"
						to={`/products/create`}>
						{t('create')}
					</Link>
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex justify-content-between flex-wrap mb-3">
						<div className="d-flex flex-wrap gap-2">
							<FilterSearch
								filterData={filterData}
								setFilterData={setFilterData}>
							</FilterSearch>
							<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
								<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
									{t('filter')}
								</Dropdown.Toggle>

								<Dropdown.Menu className="dropdown-filter">
									<div className="row">
										{/* <div className="form-group col-md-6">
												<label>{t('type')}</label>
												<Select
													isClearable
													options={productTypes}
													value={productTypes.find(option => option.id === filterData.product_type) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'product_type': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div> */}
										<div className="form-group col-md-6">
											<label>{t('status')}</label>
											<Select
												isClearable
												options={statuses}
												value={statuses.find(option => option.id === filterData.status) || ''}
												onChange={(option) => setFilterData({ ...filterData, 'status': option ? option.id : null })}
												placeholder=""
												noOptionsMessage={() => t('list_empty')}
												getOptionLabel={(option) => option.name}
												getOptionValue={(option) => option.id}
											/>
										</div>
									</div>
									<div className="d-flex justify-content-end gap-2">
										<button className="btn btn-secondary" onClick={() => setDropdownIsOpen(false)}>{t('cancel')}</button>
										<button className="btn btn-primary" onClick={() => searchWithFilter()}>{t('apply')}</button>
									</div>
								</Dropdown.Menu>
							</Dropdown>
							<button className="btn btn-outline-primary btn-wide-2"
								onClick={() => downloadExcelFile()}>
								<CustomTooltip text={t('EXCEL')}>
									<i className="uil uil-file-download-alt"></i>
								</CustomTooltip>
							</button>
							{productTypes.map((item, index) => (
								<button className={`btn btn-outline-primary ${item.id === filterData.product_type ? 'active' : ''}`}
									key={index} onClick={() => handleChangeProductType(item)}>
									{item.name}
								</button>
							))
							}
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{filterData.product_type > 0 &&
									<span className="me-2">
										<b>{t('type')}: </b>
										{findKeyFromArrayByValue(productTypes, 'id', filterData.product_type, 'name')}
									</span>
								}
								{filterData.status &&
									<span className="me-2">
										<b>{t('status')}: </b>
										{findKeyFromArrayByValue(statuses, 'id', filterData.status, 'name')}
									</span>
								}
								{filterData.search &&
									<span className="me-2">
										<b>{t('search')}: </b>
										<span>{filterData.search}</span>
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase" onClick={resetFilter}>{t('reset')}</button>
							</div>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '35px' }}>{t('image2')}</th>
									<th style={{ 'width': '20%' }}>{t('name2')}</th>
									<th style={{ 'width': '20%' }}>{t('type')}</th>
									<th style={{ 'width': '20%' }} className="text-end td-ellipsis">{t('price')}</th>
									<th style={{ 'width': '20%' }} className="text-end td-ellipsis">{t('wholesale_price')}</th>
									<th style={{ 'width': '20%' }} className="text-end td-ellipsis">{t('sale_price')}</th>
									<th style={{ 'minWidth': '33px' }}></th>
								</tr>
							</thead>
							<tbody>
								{data?.map((item, index) => (
									<tr key={index}>
										<td className="text-center">
											<CustomTooltip text={item.id}>
												{item.row_number}
											</CustomTooltip>
										</td>
										<td>
											{item.image &&
												<img src={`${uploadUrl}/products/${item.image}`}
													width={30} height={30} alt="" />
											}
										</td>
										<td className="text-primary">
											<Link to={`/products/update/${item.id}`} target="_blank" rel="noopener noreferrer">
												{item.name}
											</Link>
										</td>
										<td>{item.product_type_name}</td>
										<td className="text-end">{formatMoney(item.price, 3)}</td>
										<td className="text-end">{formatMoney(item.wholesale_price, 3)}</td>
										<td className="text-end">{formatMoney(item.sale_price, 3)}</td>
										<td>
											<div className="table-dropdown">
												<Dropdown id={`dropdown-${index}`}>
													<Dropdown.Toggle variant="outline-primary">
														<i className="uil uil-ellipsis-v"></i>
													</Dropdown.Toggle>

													<Dropdown.Menu>
														<Link to={`/products/update/${item.id}`} className="table-dropdown-item">
															<i className="uil-edit-alt"></i>
															{t('edit')}
														</Link>
														{item.status === 1 &&
															<div className="table-dropdown-item text-danger"
																onClick={() => {
																	setDeleteModalParams({ id: item.id, index: index });
																	setModalDelete(true)
																}}>
																<i className="uil-times"></i>
																{t('delete')}
															</div>
														}
														{item.status === -1 &&
															<div className="table-dropdown-item"
																onClick={() => restoreItem(item)}>
																<i className="uil-history-alt"></i>
																{t('restore')}
															</div>
														}
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination
							pagination={pagination}
							paginate={paginate}>
						</FilterPagination>
					}
				</div>
			</div>

			<DeleteModal
				modalDelete={modalDelete}
				setModalDelete={setModalDelete}
				deleteItem={deleteItem}>
			</DeleteModal>
		</>
	)
}

export default Index